<template>
  <div class="place-self-center text-2xl"> Contas </div>
</template>
